import React, { Fragment } from "react";
import styled from "styled-components";
import ProfileIntroSection from "../components/ProfileIntroSection";
import ProfileList from "../components/ProfileList";
import ProfileListItem from "../components/ProfileListItem";
import EventListItem from "../components/EventListItem";
import ImageSection from "../components/ImageSection";
import Head from "../components/Head";
import { media } from "../style/constants";
import { META } from "../utils/constants";
import { ContentWrapper, Loader } from "../style/shared";
import Link from "gatsby-link";
import { NewList } from "../components/ProfileList/style";
import Image from "../components/Image";
import { colors } from "../style/constants";

/* stylelint-disable */
const ListsSection = styled.section`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto;
  position: relative;
  grid-gap: 1rem;
  padding: 8rem 1rem 8rem 1rem;
  ${media.md`
  padding: 3rem;
  `}
  ${media.sm`
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 1fr);
    padding: 1.5rem;
  `}
  .upcoming li {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid ${colors.gray700};
  }
  .text {
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    ${media.md`
      grid-column: 1 / 5;
    `}
    ${media.sm`
      grid-row: 2 / 2;
    `}
    h1 {
      font-size: 1.3rem;
      margin-bottom: 1rem;
      max-width: 18rem;
    }
    p {
      margin-bottom: 1rem;
    }
    a {
      text-decoration: underline;
    }
  }
  .quote {
    grid-row: 1;
    grid-column: 6 / 8;
    font-size: 1.6rem;
    line-height: 1.1;
    ${media.md`
      font-size: 1.4rem;
      grid-column: 5 / 9;
    `}
    ${media.sm`
      grid-row: 1;
      grid-column: 1 / 5;
      font-size: 1.4rem;
    `}

    .byline {
      font-size: 0.8rem;
      margin-top: 1rem;
    }
  }
`;

/* stylelint-enable */

export default ({ data }) => {
  const { clients, events, mentions, articles } = data;

  return (
    <ContentWrapper>
      <Head {...META.profile} image={META.common.image} />
      <ProfileIntroSection content={() => <Fragment></Fragment>} />
      <a href="/the-burning-glass">
        <NewList>
          <Image
            src="/images/the-burning-glass-bg/tgb_bg.webp"
            alt="The Burning Glass - Singles"
            className="tbg"
            sources={[
              {
                srcset: [
                  "/images/the-burning-glass-bg/tbg_bg.avif 1x",
                  "/images/the-burning-glass-bg/tbg_bg@2x.avif 2x",
                  "/images/the-burning-glass-bg/tbg_bg.webp 1x",
                  "/images/the-burning-glass-bg/tbg_bg@2x.webp 2x",
                  "/images/the-burning-glass-bg/tbg_bg.jpg 1x",
                  "/images/the-burning-glass-bg/tbg_bg@2x.jpg 2x",
                ],
              },
            ]}
          />
          <ProfileList
            title={
              "Preview 3 songs from the upcoming album 'The Burning Glass':"
            }
            subtitle={"More info"}
            list={() =>
              clients.edges.map(({ client }, i) => (
                <ProfileListItem key={i} {...client} />
              ))
            }
          />
        </NewList>
      </a>
      <ListsSection>
        <div className="text">
          <p>
            Nausicaa has performed alongside the likes of Tiny Ruins, Angie Hart
            (Frente) and Ben Salter and premiered works at Dark Mofo, the
            Woodford Folk Festival, and the Queensland Poetry Festival.
          </p>
          <p>
            The brainchild of Simon Munro, Nausicaa grew out of his work as an
            arts producer with poetry/music project{" "}
            <a
              href="https://borrowedverse.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Borrowed Verse
            </a>
            . Prior to creating Nausicaa, Munro released four solo albums under
            the alias Alex Bell.
          </p>
          <div className="events">
            <div className="upcoming">
              <h2>Events</h2>
              <h3>Upcoming</h3>
              <ul>
                <li>
                  <h4>Dates TBA soon!</h4>
                </li>
              </ul>
            </div>
            <div className="past">
              <h3>Past</h3>
              <ul>
              <li>
                  <h4>
                    Nausicaä + Black Square String Quartet: <br />
                    Judith Wright in Song
                  </h4>
                  <p>Holy Trinity, Fortitude Valley <br />
                  <p>Friday, 14 November 2025. 7pm</p>
                  </p>
                </li>
                <li>
                 
                  <h4>
                    Nausicaä + Black Square String Quartet <br />
                    Judith Wright in Song
                  </h4>
                  <p>Zamia Theatre. Mount Tamborine, Queensland <br />
                   <p>Saturday, 15 November 2025. 7pm</p>
                  </p>
                </li>
                <li>
                  <h4>
                    <a
                      href="https://www.stickytickets.com.au/lgop9/nausicaa_judith_wright_in_song_w_lily_morris.aspx"
                      target="_blank"
                    >
                      Nausicaä: Judith Wright in Song w/ Lily Morris
                    </a>
                  </h4>
                  <p>
                    Braidwood Regional Arts Group. Braidwood NSW <br />
                    <p>Friday, 7 November 2025</p>
                  </p>
                </li>
                <li>
                  <h4>
                    <a
                      href="https://www.stickytickets.com.au/3habx/nausicaa_judith_wright_in_song_w_jhana_allan.aspx"
                      target="_blank"
                    >
                      Nausicaä: Judith Wright in Song w/ Jhana Allan
                    </a>
                  </h4>
                  <p>
                    McCrossins Mill, Uralla NSW <br />
                    <p>Sunday, 2 November 2025</p>
                  </p>
                </li>
                <li>
                  <h4>Dark Mofo 2018</h4>
                  <p>
                    Borrowed Verse w/ Tiny Ruins, Ben Salter, Angie Hart, Emily
                    Lubitz (Tinpan Orange), David Stavanger, Graham Akhurst
                  </p>
                </li>
                <li>
                  <h4>Woodford Folk Festival</h4>
                  <p>Borrowed Verse w/ Tom Cooney, The Stress of Leisure</p>
                </li>
                <li>
                  <h4>Queensland Poetry Festival</h4>
                  <p>Borrowed Verse w/ Ben Salter, Graham Akhurst</p>
                </li>
                <li>
                  <h4>Two Fires Festival</h4>
                  <p>Braidwood, NSW</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="quote">
          “…Equal parts Paul Simon and Nick Drake. It’s wonderful, beautiful…”
          <div className="byline">David Faulkner — The Saturday Paper </div>
        </div>
      </ListsSection>
      <ImageSection></ImageSection>
    </ContentWrapper>
  );
};

export const homeQuery = graphql`
  query HomeQuery {
    clients: allClientsJson {
      edges {
        client: node {
          name
          url
        }
      }
    }
    events: allEventsJson {
      edges {
        event: node {
          year
          position
          company
        }
      }
    }
    mentions: allMentionsJson {
      edges {
        mention: node {
          name
          url
        }
      }
    }
    articles: allArticlesJson {
      edges {
        article: node {
          name
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js